import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68a1682e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "app-header" }
const _hoisted_3 = {
  key: 0,
  class: "text-primary text-4xl animate-pulse w-full flex justify-center pt-8"
}
const _hoisted_4 = {
  key: 1,
  class: "p-5 text-lg font-semibold text-primary flex items-center"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-black" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, " page(s)", -1))
const _hoisted_13 = { class: "w-full h-full shadow-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Loading... "))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createElementVNode("button", {
              disabled: _ctx.page <= 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPage(_ctx.page - 1))),
              class: "hover:bg-gray-100"
            }, _hoisted_7, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.page) + " / " + _toDisplayString(_ctx.count), 1),
            _createElementVNode("button", {
              disabled: _ctx.page >= _ctx.count,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPage(_ctx.page + 1))),
              class: "hover:bg-gray-100"
            }, _hoisted_11, 8, _hoisted_9),
            _hoisted_12
          ]))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_vue_pdf_embed, {
        ref: "pdfRef",
        source: _ctx.file,
        page: _ctx.page,
        onPasswordRequested: _ctx.handlePasswordRequest,
        onRendered: _ctx.handleDocumentRender
      }, null, 8, ["source", "page", "onPasswordRequested", "onRendered"])
    ])
  ]))
}